// TODO - remove lint disable when editing this file
/* eslint-disable */
import CONSTANTS from '~/constants'

export default function(ans, opts = {}) {
  const { theFetch = fetch } = opts

  return theFetch(`${CONSTANTS.TRIDENT_ROUTE_COMPOSER_API}/v1/ans/denorm`, {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
    body: JSON.stringify(ans),
  })
    .then((response) => {
      if (!response.ok) {
        throw Error(
          `Unable to denormalize. HTTP Error: ${response.status} ${response.statusText}`
        )
      }
      return response.json()
    })
    .then((ansArray) => {
      return ansArray.map((ansObj) => {
        if (['image'].indexOf(ansObj.type) !== -1) {
          ansObj.referent_properties = ansObj.referent_properties || {}
        }
        return ansObj
      })
    })
}
